import React from 'react';
import {
  Box,
  Divider,
  Heading,
  HStack,
  Icon,
  Link,
  SimpleGrid,
  Stack,
  Text,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { FaInstagram } from 'react-icons/fa';
import { MdAccessTime, MdEmail, MdLocationOn, MdPhone } from 'react-icons/md';
import Container from '../ui/Container';
import site from '../../config/site';
import SiesaLogo from '../ui/SiesaLogo';

const SOLUTIONS = [

  { label: 'Servicios eléctricos', href: '/services' },
  { label: 'Mantenimiento eléctrico', href: '/services' },
  { label: 'Automatización y paneles', href: '/services' },
  { label: 'Estudios y diagnósticos', href: '/services' },
  { label: 'Digitalización de planos', href: '/services' },
];

const COMPANY = [
  { label: 'Nosotros', href: '/about' },
  { label: 'Proyectos', href: '/projects' },
  { label: 'Siesa QR App', href: '/siesa-qr-app' },
  { label: 'Trabaje con nosotros', href: '/contact?subject=other' },
  { label: 'Proveedores', href: '/contact?subject=suppliers' },
];

function ColumnTitle({ children }) {
  return (
    <Heading as="h2" fontSize="md" color="white" mb={4}>
      {children}
    </Heading>
  );
}

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <Box
      as="footer"
      bg="brand.950"
      color="whiteAlpha.900"
      pt={{ base: 12, md: 16 }}
      pb={6}
    >
      <Container>
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 4 }}
          spacing={{ base: 8, lg: 10 }}
        >
          <Stack spacing={4}>
            <SiesaLogo variant="footer" h={{ base: '110px', md: '145px' }} w="auto" />
            <Text fontSize="sm">
              {site.legalName}. Ofrecemos soluciones eléctricas integrales con
              calidad, seguridad y eficiencia para la industria, el comercio y
              la construcción.
            </Text>
            <Link
              href={site.social.instagram.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="SIESA en Instagram"
              w="44px"
              h="44px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              bg="whiteAlpha.200"
              borderRadius="full"
              _hover={{ bg: 'whiteAlpha.300' }}
            >
              <Icon as={FaInstagram} />
            </Link>
          </Stack>

          <Stack as="nav" aria-label="Servicios" spacing={2}>
            <ColumnTitle>Servicios</ColumnTitle>
            {SOLUTIONS.map(item => (
              <Link
                key={item.label}
                as={RouterLink}
                to={item.href}
                variant="footer"
                fontSize="sm"
              >
                {item.label}
              </Link>
            ))}
          </Stack>

          <Stack as="nav" aria-label="Compañía" spacing={2}>
            <ColumnTitle>Compañía</ColumnTitle>
            {COMPANY.map(item => (
              <Link
                key={item.label}
                as={RouterLink}
                to={item.href}
                variant="footer"
                fontSize="sm"
              >
                {item.label}
              </Link>
            ))}
          </Stack>

          <Stack spacing={3}>
            <ColumnTitle>Contacto</ColumnTitle>
            <Link
              href={site.phone.href}
              variant="footer"
              fontSize="sm"
              display="flex"
              gap={2}
            >
              <Icon as={MdPhone} aria-hidden="true" mt={1} />
              <span>{site.phone.label}</span>
            </Link>
            <Link
              href={site.mobile.href}
              variant="footer"
              fontSize="sm"
              display="flex"
              gap={2}
            >
              <Icon as={MdPhone} aria-hidden="true" mt={1} />
              <span>{site.mobile.label}</span>
            </Link>
            <Link
              href={site.email.href}
              variant="footer"
              fontSize="sm"
              display="flex"
              gap={2}
            >
              <Icon as={MdEmail} aria-hidden="true" mt={1} />
              <span>{site.email.label}</span>
            </Link>
            <HStack align="flex-start" spacing={2} fontSize="sm">
              <Icon as={MdLocationOn} aria-hidden="true" mt={1} />
              <Text>{site.location.label}</Text>
            </HStack>
            <HStack align="flex-start" spacing={2} fontSize="sm">
              <Icon as={MdAccessTime} aria-hidden="true" mt={1} />
              <Text>
                {site.hours.weekdays}
                <br />
                {site.hours.saturday}
              </Text>
            </HStack>
          </Stack>
        </SimpleGrid>

        <Divider borderColor="whiteAlpha.300" my={8} />

        <Stack
          direction={{ base: 'column', md: 'row' }}
          justify="space-between"
          align={{ base: 'flex-start', md: 'center' }}
          spacing={3}
          fontSize="xs"
        >
          <Text>
            © {year} {site.legalName}. Todos los derechos reservados.
          </Text>
          <HStack spacing={5}>
            <Link as={RouterLink} to="/privacy-policy" variant="footer">
              Política de privacidad
            </Link>
            <Link as={RouterLink} to="/terms" variant="footer">
              Términos y condiciones
            </Link>
          </HStack>
        </Stack>
      </Container>
    </Box>
  );
}
